/**
 * Created by lilei on 2018/1/10.
 */
export default {
    overrides: {
        MuiButton:{
            root:{
                margin:'0 5px'
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/theme.js